import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaCompactDisc, FaCogs, FaCube, FaPrint, FaPenNib, FaStore } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Productos = () => {
    const { t } = useTranslation();

    const productCategories = [
        {
            key: 'laser',
            icon: FaCompactDisc,
            products: ['corporeas', 'carteles_interior', 'acrilicos_luminosos', 'grabado_industrial']
        },
        {
            key: 'cnc',
            icon: FaCogs,
            products: ['letras_gigantes', 'paneles_decorativos', 'mobiliario_mdf']
        },
        {
            key: 'thermoforming',
            icon: FaCube,
            products: ['logos_3d', 'exhibidores_termoformados']
        },
        {
            key: 'print_cut',
            icon: FaPrint,
            products: ['impresion_vehicular', 'microperforados', 'vinilos_decorativos', 'esmerilados', 'floor_graphics']
        },
        {
            key: 'uv_flatbed',
            icon: FaPenNib,
            products: ['lonas', 'impresion_rigidos', 'carteleria_obra']
        },
        {
            key: 'displays_sales',
            icon: FaStore,
            products: ['porta_pendones', 'topes_gondola', 'exhibidores_mesa', 'portafolletos']
        }
    ];

    return (
        <div id="productos-page" style={{ paddingTop: '100px', paddingBottom: '50px', backgroundColor: '#f9f9f9' }}>
            <Container>
                {/* Header */}
                <Row className="mb-5 text-center">
                    <Col lg={8} className="mx-auto">
                        <h1 className="display-4 fw-bold mb-3" style={{ color: '#1E5096' }}>{t('products.pageTitle')}</h1>
                        <p className="lead text-muted">{t('products.pageSubtitle')}</p>
                    </Col>
                </Row>

                {/* Categories Grid */}
                <Row className="justify-content-center g-4">
                    {productCategories.map((cat, index) => (
                        <Col key={index} xs={12} md={6} lg={4}>
                            <Card className="h-100 border-0 shadow-sm hover-card" style={{ transition: 'transform 0.3s' }}>
                                <Card.Body className="p-4">
                                    <div className="d-flex align-items-center mb-4">
                                        <div className="icon-box me-3 p-3 rounded-circle" style={{ backgroundColor: '#e9ecef', color: '#1E5096' }}>
                                            <cat.icon size={24} />
                                        </div>
                                        <h3 className="h5 fw-bold mb-0">{t(`products.categories.${cat.key}.title`)}</h3>
                                    </div>

                                    <ul className="list-unstyled">
                                        {cat.products.map((prod, i) => (
                                            <li key={i} className="mb-2 pb-2 border-bottom border-light">
                                                <span style={{ fontSize: '0.95rem', color: '#555' }}>
                                                    {t(`products.items.${prod}`)}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </Card.Body>
                                <Card.Footer className="bg-white border-0 p-4 pt-0">
                                    <Button variant="outline-primary" size="sm" as={Link} to="/contacto" className="w-100 rounded-pill">
                                        {t('common.consult', 'Consultar')}
                                    </Button>
                                </Card.Footer>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* CTA */}
                <Row className="mt-5 text-center">
                    <Col>
                        <div className="p-5 rounded-3 text-white" style={{ background: 'linear-gradient(45deg, #1E5096, #0d6efd)' }}>
                            <h2 className="fw-bold mb-3 text-white">{t('products.custom_request_title')}</h2>
                            <p className="mb-4">{t('products.custom_request_desc')}</p>
                            <Button variant="light" size="lg" as={Link} to="/contacto" className="px-5 rounded-pill shadow">
                                {t('nav.contact')}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>

            <style jsx>{`
                .hover-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
                }
            `}</style>
        </div>
    );
};

export default Productos;
